import React from "react";

const ConsumerProducts = (props) => {
  const options = [
    {
      text: 'INTERAC e-Transfer',
      handler: props.actionProvider.handleEtransfer,
      id: 1,
    },
    {
      text: 'INTERAC Debit',
      handler: props.actionProvider.handleDebit,
      id: 2
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container'>{optionsMarkup}</div>;
};

export default ConsumerProducts;